<template>
    <div
        :id="id"
        class="tl-country"
    >
        <span
            v-if="hasLabel"
            class="tl-country-label"
        >{{ label }}</span>
        <div
            v-if="displayName"
            class="tl-country-value"
        >
            <CountryFlag
                v-if="showFlag"
                :country-code="normalizedCode"
            />
            <span class="tl-country-name">{{ displayName }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CountryFlag from 'widget-components/components/InputCountry/CountryFlag.vue'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
    id?: string
    label?: string | null
    countryCode?: string | null
    countryName?: string | null
    displayCountryFlag?: boolean
}>()

const normalizedCode = computed(() => props.countryCode?.trim().toUpperCase() || '')
const displayName = computed(() => props.countryName?.trim() || normalizedCode.value)
const showFlag = computed(() => !!props.displayCountryFlag && !!normalizedCode.value)
const hasLabel = computed(() => !!props.label?.trim())
</script>

<style lang="sass" scoped>
@import "./Country.sass"
</style>
